import React, { useState } from "react";
import NavbarModulo from "../components/NavbarModulo";

export default function LaboratorioHome() {
    return (
        <NavbarModulo modulo={{ modulo: "Laboratorio" }} titulo="Laboratorio" />
    );
}
